module.exports = __webpack_public_path__ + "img/olympic-soccer.20423d0b.png";